'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBemReact = require('@yandex-lego/i-bem-react');

exports.default = (0, _iBemReact.declMod)({ theme: 'normal' }, {
    block: 'popup2',
    willInit: function willInit() {
        this.__base.apply(this, arguments);

        this.defaultMainOffset = 5;
        this.defaultViewportOffset = 5;
    }
});